function SPExistingServiceJobMarker({
  text = '2',
  size = 21.5,
  textColor = '#ffffff',
  boxColor = '#EA9674',
  strokeColor = '#BB6F6B',
  strokeWidth = 1.2,
}) {
  const svgNS = 'http://www.w3.org/2000/svg';

  const svg = document.createElementNS(svgNS, 'svg');

  svg.setAttribute('width', size);
  svg.setAttribute('height', size);
  svg.setAttribute('viewBox', '0 0 21.5 21.5');

  // Diamond (rotated square)
  const rect = document.createElementNS(svgNS, 'rect');

  rect.setAttribute('x', '3.75');
  rect.setAttribute('y', '3.75');

  rect.setAttribute('width', '14');
  rect.setAttribute('height', '14');

  rect.setAttribute('rx', '1.5');
  rect.setAttribute('ry', '1.5');

  rect.setAttribute('fill', boxColor);
  rect.setAttribute('stroke', strokeColor);
  rect.setAttribute('stroke-width', strokeWidth);

  // Rotate around center
  rect.setAttribute('transform', 'rotate(45 10.75 10.75)');

  svg.appendChild(rect);

  // Text
  const textElement = document.createElementNS(svgNS, 'text');

  textElement.setAttribute('x', '10.75');
  textElement.setAttribute('y', '10.75');

  textElement.setAttribute('fill', textColor);

  textElement.setAttribute('font-family', 'Arial, sans-serif');
  textElement.setAttribute('font-weight', '700');

  const fontSize = text.toString().length >= 2 ? 7 : 9;

  textElement.setAttribute('font-size', fontSize);

  textElement.setAttribute('text-anchor', 'middle');
  textElement.setAttribute('dominant-baseline', 'middle');

  // tiny optical adjustment
  textElement.setAttribute('dy', '0.4');

  textElement.textContent = text.toString();

  svg.appendChild(textElement);

  return svg;
}

export default SPExistingServiceJobMarker;
